import React from "react";
import {BrowserRouter as Router, Route, Routes} from "react-router-dom";
import {seismicTheme, Theme} from '@seismic/mantle'
import {Web} from "./pages/Web";
import {Content} from "./pages/Content";
import {ContentUsage} from "./pages/ContentUsage";
import {Auth} from "./pages/Auth";
import {SignIn} from "./pages/SignIn";
import "./App.css";
import {Livesend} from "./pages/Livesend";
import {EmailTrainer} from "./pages/EmailTrainer";
import {Meeting} from "./pages/Meeting";
import {Pages} from "./pages/Pages";
import {MeetingRedirect} from "./pages/MeetingRedirect";
import {Lineage} from "./pages/Lineage";
import {VisualVersionHistory} from "./pages/VisualVersionHistory";
import {Clusters} from "./pages/Clusters";
import {LivedocGeneration} from "./pages/LivedocGeneration";

export default function App() {
    
    return (
        <>
            <Theme theme={seismicTheme({useGlobal: true, defaultPortalContainerSelector: '.mntl-portals'})}>
                <Router>
                    <Routes>
                        <Route exact path={"/Web/*"} element={<Web/>}/>
                        <Route exact path={"/Meeting/*"} element={<Meeting/>}/>
                        <Route exact path={"/Content/*"} element={<Content/>}/>
                        <Route exact path={"/ContentUsage/*"} element={<ContentUsage/>}/>
                        <Route exact path={"/Pages/*"} element={<Pages/>}/>
                        <Route exact path={"/Livesend/*"} element={<Livesend/>}/>
                        <Route exact path={"/EmailTrainer/*"} element={<EmailTrainer/>}/>
                        <Route exact path={"/Lineage/*"} element={<Lineage/>}/>
                        <Route exact path={"/VisualVersionHistory/*"} element={<VisualVersionHistory/>}/>
                        <Route exact path={"/Clusters/*"} element={<Clusters/>}/>
                        <Route exact path={"/LivedocGeneration/*"} element={<LivedocGeneration/>}/>
                        <Route exact path={"/Auth/*"} element={<Auth/>}/>
                        <Route exact path={"/SignIn/*"} element={<SignIn/>}/>
                        <Route exact path={"/MeetingRedirect/*"} element={<MeetingRedirect/>}/>
                    </Routes>
                </Router>
                <div className='mntl-portals'/>
            </Theme>
        </>
    );
}
